import { convertFromRaw } from "draft-js";
import { stateToHTML } from "draft-js-export-html";

const convertContentToHtml = content => {
  try {
    const contentState = convertFromRaw(content);
    const htmlString = stateToHTML(contentState);
    const cleanHtmlString = htmlString.trim() // remove newlines / carriage returns
    .replace(/\n/g, "") // remove whitespace between tags
    .replace(/>[\t ]+</g, "><");
    return cleanHtmlString;
  } catch {
    return "";
  }
};

export default convertContentToHtml;